<template>
    <div :class="['badge-activity-status', `is-${tag.type}`]">
        <CompassIcon v-if="tag.icon" size="extra-small" :icon="tag.icon" />
        <span class="typographies-paragraph-small-regular">{{ tag.label }}</span>
    </div>
</template>

<script>
export default {
    props: {
        tag: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.badge-activity-status {
    display: flex;
    padding: 0 var(--spacing-0);
    gap: var(--spacing-0);
    border-radius: var(--spacing-0);
    align-items: center;
    width: fit-content;
    flex-shrink: 0;

    &.is-error {
        background-color: var(--colors-common-background-alert-default);
        color: var(--colors-common-text-contrast-default);
    }

    &.is-warning {
        background-color: var(--colors-common-background-warning-subtle);
        color: var(--colors-common-text-subtle-default);
    }
}
</style>
